import microphoneIcon from "../../../Assets/icon/explore/microphone.svg";
import fileIcon from "../../../Assets/icon/explore/file.svg";
import keyboardIcon from "../../../Assets/icon/explore/keyboard-teal.svg";
import chevronIcon from "../../../Assets/icon/explore/chevron-right.svg";
import { SOURCE_KIND_LABEL } from "../copy";
import { relativeDay } from "../format";

/**
 * One Personal Dialogue (Figma 9154:8266 / 10873:24975): source tile, title,
 * "Recording · 3 days ago", chevron.
 *
 * `source_kind` is being added to aris-ai (§7 E5). Until it arrives every row
 * takes the neutral document tile and no kind label — never a guess at how the
 * Dialogue was made. The date comes from `created_at` (library rows) and is
 * simply absent on feed cards, which don't carry it.
 */

const KIND = {
  RECORDING: { icon: microphoneIcon, tone: "orange" },
  DOCUMENT: { icon: fileIcon, tone: "blue" },
  PHOTO: { icon: fileIcon, tone: "blue" },
  TEXT: { icon: keyboardIcon, tone: "teal" },
};

/** Loose match: the DCI method names may be spelled RECORD / UPLOAD / PASTE. */
const normaliseKind = (raw) => {
  const k = String(raw || "").toUpperCase();
  if (!k) return null;
  if (k.includes("RECORD") || k.includes("AUDIO")) return "RECORDING";
  if (k.includes("PHOTO") || k.includes("IMAGE")) return "PHOTO";
  if (k.includes("DOC") || k.includes("UPLOAD") || k.includes("FILE")) return "DOCUMENT";
  if (k.includes("TEXT") || k.includes("PASTE") || k.includes("TYPE")) return "TEXT";
  return null;
};

/**
 * The row's status badge (Figma 06 · 11712:29555; aris-ai plan 52/53): In Progress,
 * Paused, Completed, Archived. Not Started has no badge.
 */
export const STATUS_BADGE = {
  IN_PROGRESS: { label: "In Progress", tone: "progress" },
  PAUSED: { label: "Paused", tone: "paused" },
  COMPLETED: { label: "Completed", tone: "done" },
  ARCHIVED: { label: "Archived", tone: "archived" },
};

export const personalSubtitle = (item) => {
  const kind = normaliseKind(item?.source_kind);
  // DCI v27 D-7: `display_at` is creation time until started, last activity after.
  const when = relativeDay(item?.display_at || item?.created_at);
  const parts = [kind && SOURCE_KIND_LABEL[kind], when].filter(Boolean);
  return parts.length > 0 ? parts.join(" · ") : item?.context_line || "";
};

function PersonalDialogueRow({ item, onOpen }) {
  const kind = normaliseKind(item?.source_kind);
  const look = KIND[kind] || { icon: fileIcon, tone: "blue" };
  const subtitle = personalSubtitle(item);
  const badge = STATUS_BADGE[item?.status];

  return (
    <button type="button" className="ex-plist__row" onClick={() => onOpen?.(item)}>
      <span className={`ex-plist__tile ex-plist__tile--${look.tone}`}>
        <img src={look.icon} alt="" width="24" height="24" />
      </span>
      <span className="ex-plist__text">
        <span className="ex-plist__title">{item.title}</span>
        {(badge || subtitle) && (
          <span className="ex-plist__meta">
            {badge && (
              <span className={`ex-plist__badge ex-plist__badge--${badge.tone}`}>
                {badge.label}
              </span>
            )}
            {subtitle && <span className="ex-plist__sub">{subtitle}</span>}
          </span>
        )}
      </span>
      <span className="ex-plist__chevron">
        <img src={chevronIcon} alt="" width="16" height="16" />
      </span>
    </button>
  );
}

export default PersonalDialogueRow;
